module.exports = __webpack_public_path__ + "img/prelaunch.fc68019f.svg";